import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TeamTypeConfiguration } from "@common/ADAPT.Common.Model/organisation/team-type-configuration";
import { CommonTeamsService } from "@org-common/lib/teams/common-teams.service";

@Component({
    selector: "adapt-select-team-type",
    standalone: false,
    templateUrl: "./select-team-type.component.html",
    styleUrl: "./select-team-type.component.scss",
})
export class SelectTeamTypeComponent implements OnInit {
    @Input({ required: true }) public teamTypeConfiguration!: TeamTypeConfiguration;
    @Input() public disabled = false;
    @Output() public teamTypeConfigurationChange = new EventEmitter<TeamTypeConfiguration>();

    public teamTypeConfigurations: TeamTypeConfiguration[] = [];

    public constructor(private commonTeamsService: CommonTeamsService) {}

    public async ngOnInit() {
        this.teamTypeConfigurations = await this.commonTeamsService.promiseToGetTeamTypeConfigurations();
    }
}
